import { ApolloClient, gql, NormalizedCacheObject, useQuery } from "@apollo/client";
import { Query } from "../types/generated/graphql";

export const useGetOneYouTubeProfileFeed = (client: ApolloClient<NormalizedCacheObject>, id: string) => {
  type T = Pick<Query, 'getOneYouTubeProfileFeed'>;
  const ret = useQuery<T>(QUERY_GET_ONE_YOUTUBE_PROFILE_FEED, { 
    client, variables: { id },
    fetchPolicy: "network-only", // Always fetch from the server
  });

  return ret;
}

const QUERY_GET_ONE_YOUTUBE_PROFILE_FEED = gql`
  query fct($id: String!) {
    getOneYouTubeProfileFeed(id: $id) {
      # FeedVideo fields
      id
      title
      description
      author {
        id
        name
      }
      thumbnails {
        url
        height
        width
      }
      duration
      snapshot_date
      recommended_on
      is_watched
      is_live
      published
      view_count
      feedback {
        dontRecommendChannel {
          token
          undoToken
        }
        notInterested {
          token
          undoToken
        }
      }
    }
  }
`;
